import React, { memo, useState, useEffect, useCallback, useRef, useMemo } from 'react'
import styles from './index.module.less'
import InnerDrawer from '../InnerDrawer'
import { Divider } from 'antd'
import clsx from 'clsx'
import Svg1 from '@/components/icon/systemMenu/1'
import Svg2 from '@/components/icon/systemMenu/2'
import Svg3 from '@/components/icon/systemMenu/3'
import Svg4 from '@/components/icon/systemMenu/4'
import Svg5 from '@/components/icon/systemMenu/5'
import Svg6 from '@/components/icon/systemMenu/6'
import { SystemEnum, MenuEnum } from '@/config/enum'
import useGlobalStore from '@/store/useGlobalStore'
import { useShallow } from 'zustand/react/shallow'
import { useNavigate } from 'react-router-dom'
import { useClickAway } from 'ahooks'
import { getCmsUrl } from '@/utils/env'
import { isDebugMode } from '@/utils/syetem'


const Menu = ({ open, children, onClose, onClick }: any) => {
  const navigate = useNavigate()
  const setGlobalState = useGlobalStore.setState
  const { systemKey, systemMenuOpen, productInfo } = useGlobalStore(useShallow(s => ({
    systemKey: s.systemKey,
    systemMenuOpen: s.systemMenuOpen,
    productInfo: s.productInfo
  })))


  const defaultMenu = {
    title: MenuEnum.SYSTEM,
    key: SystemEnum.SYSTEM,
    icon: <Svg1 className={styles['icon']} />
  }
  // const restMenu = [
  //   {
  //     title: MenuEnum.XMYJ,
  //     key: SystemEnum.YJGL,
  //     icon: <Svg2 className={styles['icon']} />
  //   },
  //   {
  //     title: MenuEnum.ZJZB,
  //     key: SystemEnum.ZBGL,
  //     icon: <Svg3 className={styles['icon']} />
  //   },
  //   // {
  //   //   title: MenuEnum.LJXT,
  //   //   key: SystemEnum.LJXT,
  //   //   icon: <Svg4 className={styles['icon']} />
  //   // },
  //   {
  //     title: MenuEnum.ZXZY,
  //     key: SystemEnum.ZXZY,
  //     icon: <Svg5 className={styles['icon']} />,
  //     // onClick: () => { window.open("http://192.168.13.140:3001/#/login") }
  //     onClick: () => { window.open(getCmsUrl()) }
  //   }
  // ]
  const restMenu = [
    // 项目业绩
    // ...(isDebugMode()
    //   ? [
    //     {
    //       title: MenuEnum.XMYJ,
    //       key: SystemEnum.YJGL,
    //       icon: <Svg2 className={styles['icon']} />
    //     },
    //   ] : []),
    {
      title: MenuEnum.XMYJ,
      key: SystemEnum.YJGL,
      icon: <Svg2 className={styles['icon']} />
    },
    // 造价指标
    {
      title: MenuEnum.ZJZB,
      key: SystemEnum.ZBGL,
      icon: <Svg3 className={styles['icon']} />
    },
    {
      title: MenuEnum.ZLWD,
      key: SystemEnum.ZLWD,
      icon: <Svg4 className={styles['icon']} />
    },
    {
      title: MenuEnum.SHRY,
      key: SystemEnum.SHRY,
      icon: <Svg6 className={styles['icon']} />
    },
    // {
    //   title: MenuEnum.LJXT,
    //   key: SystemEnum.LJXT,
    //   icon: <Svg4 className={styles['icon']} />
    // },
    // 开发模式可见
    // isDebugMode
    ...(isDebugMode()
      ? [
        {
          title: MenuEnum.ZXZY,
          key: SystemEnum.ZXZY,
          icon: <Svg5 className={styles['icon']} />,
          onClick: () => {
            window.open(getCmsUrl());
          },
        },
      ]
      : []),
  ]
  const authRestMenu = useMemo(() => {
    const res = restMenu.filter((item: any) => productInfo.includes(item.key))
    return res
    // 上海燃气入口当前需要固定展示，不走产品权限过滤。
    // return res.concat(
    //   {
    //     title: MenuEnum.SHRY,
    //     key: SystemEnum.SHRY,
    //     icon: <Svg6 className={styles['icon']} />
    //   }
    // );
  }, [productInfo, restMenu])

  // 是否有主数据权限
  const hasMainDataAuth = useMemo(() => {
    return productInfo.includes(SystemEnum.SYSTEM)
  }, [productInfo, restMenu])

  const handleClick = (key, item) => {
    if (item?.onClick) {
      item.onClick()
      return;
    }
    setGlobalState({ systemKey: key })
    // 加载对应路由
    if (key === SystemEnum.SYSTEM) {
      navigate('/project-center/list')
    } else if (key === SystemEnum.ZBGL) {
      // navigate('/indicator/list')
      // navigate('/project-center/englist')
      navigate('/indicator/englist')
    } else if (key === SystemEnum.YJGL) {
      navigate('/cloud-project/list')
    } else if (key === SystemEnum.ZLWD) {
      navigate('/document/domainList')
    } else if (key === SystemEnum.SHRY) {
      navigate('/shry/unit-price-standard')
    }
  }

  return (
    <div className={styles['container']}>
      {hasMainDataAuth ? <React.Fragment>
        <div className={clsx(styles['item_wrap'], styles['default'],)}>
          <div onClick={() => handleClick(SystemEnum.SYSTEM, null)} key={defaultMenu.key} className={clsx(styles['item'], styles['default'], { [styles['active']]: systemKey === SystemEnum.SYSTEM })}>
            <div className={styles.left}>
              {defaultMenu.icon}
              {defaultMenu.title}
            </div>
            <div className={styles.right}>

            </div>

          </div>
        </div>
        <Divider className={styles['divider']} />
      </React.Fragment> : null}

      <div className={clsx(styles['bottom'], { [styles['bottom_no_main_data']]: !hasMainDataAuth })}>
        {
          authRestMenu.map((item: any) => {
            return (
              <div className={styles['item_wrap']} key={item.key} >
                <div onClick={() => handleClick(item.key, item)} className={clsx(styles['item'], { [styles['active']]: systemKey === item.key })}>
                  {item.icon}
                  {item.title}
                </div>
              </div>
            )
          })
        }
      </div>


    </div>
  )
}

const index = ({ onClose, onClick }: any) => {
  const { systemMenuOpen } = useGlobalStore(useShallow(s => ({
    systemMenuOpen: s.systemMenuOpen
  })))
  return (<InnerDrawer open={systemMenuOpen} onClose={onClose}  >
    <Menu onClick={onClick} />
  </InnerDrawer>)
}

export default index
